import { IConversion, IUnitRequestType } from '../unit/unit.types';
import { IStorageArea } from '../../storageArea/storageArea.types';

export interface IAccount {
  id: number;
  name: string;
}

export interface IGeneralInfo {
  name: string;
  account: IAccount;
  storageArea: IStorageArea;
  unitOfMeasure: IUnitRequestType;
  parValue: number;
}

export interface IIngredientRequestType {
  generalInfo?: IGeneralInfo;
  conversions?: IConversion[]; // New field for conversions
  quantityOnHand?: number;
  avgValue?: number;
  status?: string;
  restaurantId?: number;
  createdBy?: number;
  updatedBy?: number;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface IAllIngredientsResponseType {
  response: {
    success: boolean;
    data: { ingredients: [IIngredientGetAllDataResponse] } | [];
    message: string;
    error: string | null;
  };
  statusCode: number;
}

export interface IIngredientByIdResponseType {
  response: {
    success: boolean;
    data: { ingredient: IIngredientDataResponse | null };
    message: string;
  };
  statusCode: number;
}

export interface ICreatedIngredientResponseType {
  success: boolean;
  data: IIngredientRequestType;
  message: string;
}

export interface IIngredientDataResponse {
  id: number;
  generalInfo?: IGeneralInfo;
  conversions?: IConversion[]; // New field for conversions
  quantityOnHand?: number;
  avgValue?: number;
  status?: string;
  restaurantId?: number;
  createdBy?: string;
  updatedBy?: string;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface IIngredientLogDataResponse {
  id?: number;
  restaurantId?: number;
  source?: string;
  changeType?: string;
  existingQuantity?: number;
  changeInQuantity?: number;
  newQuantity?: number;
  createdAt?: Date;
}

export interface IIngredientGetAllDataResponse {
  id?: number;
  name?: string;
  accountId: number;
  account: IAccount;
  unitOfMeasure: string;
  unitOfMeasureOption: { id: number; name: string; abbreviation: string };
  convertedQoH: ConvertedQoH[];
  storageArea: string;
  parValue: number;
  quantityOnHand?: string;
  avgValue?: number;
  status?: string;
  restaurantId?: number;
  createdBy?: string;
  updatedBy?: string;
  totalValue: string;
  createdAt?: Date;
  updatedAt?: Date;
  usedInRecipe?: boolean;
}
interface UnitType {
  id: number;
  name: string;
  abbreviation: string;
}
interface ConvertedQoH {
  id: number;
  name: string;
  abbreviation: string;
  conversionFactor: string;
  quantityOnHand: number;
  fromUnit: UnitType;
}

export enum IngredientRecordStatus {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
  ARCHIVED = 'Archived',
}

export interface ChartsOfAccountDto {
  id: number;
  name: string;
  glCodeId: number;
}

export interface AllChartsOfAccountResponseDto {
  response: {
    data: { chartsOfAccounts: ChartsOfAccountDto[] | null };
    success: boolean;
    message: string;
    error: string | null;
  };
  statusCode: number;
}

export interface ChartsOfAccountResponse {
  chartsOfAccounts: ChartsOfAccountDto[];
}
export enum IngredientTypes {
  INGREDIENT = 'Ingredient',
  NON_INGREDIENT = 'Non-Ingredient',
}

export enum IngredientChangeInTypes {
  INCREASE = 'Increase',
  DECREASE = 'Decrease',
}

export enum PARAMS_MODULES_NAMES {
  INGREDIENT = 'ingredient',
  NON_INGREDIENT = 'non-ingredient',
  VENDOR = 'vendor',
  INVOICE = 'invoice',
}

export interface IIngredientRecipes {
  id: number;
  name: string;
  recipeType: string;
  quantity: string;
}

export interface IIngredientRecipesResponse {
  response: {
    success: boolean;
    data: { ingredientRecipes: IIngredientRecipes[] } | [];
    message: string;
    error: string | null;
  };
  statusCode: number;
}
